export const WALLET_READY_MESSAGE = 'wallet:ready';

export const WALLET_RESIZE_MESSAGE = 'wallet:resize';

export const WALLET_NAVIGATE_MESSAGE_TYPE = 'wallet:navigate';

export const WALLET_WIDGET_CONFIG_MESSAGE_TYPE = 'wallet:widget:config';
